import { setRangeMin } from './helpers';

export const setFromMKADMin = setRangeMin('from_mcad_km');
